import styled from 'styled-components';

import Icon from 'components/Icon';

export const AddDetailsIcon = styled(Icon).attrs({
  name: 'add-details'
})`
  height: 20px;
  color: ${({hasFeedback}) => (hasFeedback ? '#0172CB' : '#757575')};
`;

export const AddDetailsButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 8px;
  width: 100%;
  height: 39px;
  background-color: ${({hasFeedback}) => (hasFeedback ? '#E0EBF4' : ' #FFFFFF')};
  border: 1px solid #ececec;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #757575;
  cursor: pointer;
`;

export const StyledDiv = styled.div`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: ${({isMobile}) => (isMobile ? '14px' : '16px')};
  line-height: 24px;
`;
